import { ElementType } from "react";

import { useDisconnectCosignPropertyMapping } from "manager/hooks/api/cosignQueries";
import { ICosignMappedProperty } from "manager/hooks/api/integrationQueries";
import ConfirmationModal from "shared/components/Modals/ConfirmationModal";
import useModal from "shared/hooks/useModal";

interface UseCosignDisconnectActionOptions {
  onDisconnectSuccess?: () => void;
}

interface OpenCosignDisconnectConfirmationParams {
  property: ICosignMappedProperty;
  openModalDialog: (
    modal: ElementType,
    context: Record<string, unknown>
  ) => void;
  disconnectCosignPropertyMapping: (params: {
    cosignPropertyId: number | string;
  }) => void;
}

export const getCosignDisconnectConfirmationCopy = (propertyName: string) =>
  `Are you sure you want to disconnect ${propertyName} from Cosign? Existing Cosign applications on this property will not be affected.`;

export const openCosignDisconnectConfirmation = ({
  property,
  openModalDialog,
  disconnectCosignPropertyMapping,
}: OpenCosignDisconnectConfirmationParams) => {
  openModalDialog(ConfirmationModal, {
    title: "Disconnect Cosign Property",
    submitButtonLabel: "Disconnect",
    subtitle: getCosignDisconnectConfirmationCopy(property.name),
    onConfirm: () =>
      disconnectCosignPropertyMapping({
        cosignPropertyId: property.mappingId,
      }),
  });
};

export const useCosignDisconnectAction = ({
  onDisconnectSuccess,
}: UseCosignDisconnectActionOptions = {}) => {
  const { openModalDialog } = useModal();
  const {
    disconnectCosignPropertyMapping,
    isDisconnectingCosignPropertyMapping,
  } = useDisconnectCosignPropertyMapping({
    onSuccess: onDisconnectSuccess,
  });

  const disconnectProperty = (property: ICosignMappedProperty) =>
    openCosignDisconnectConfirmation({
      property,
      openModalDialog,
      disconnectCosignPropertyMapping,
    });

  return {
    disconnectProperty,
    isDisconnectingCosignPropertyMapping,
  };
};
